module.exports = __webpack_public_path__ + "img/1557614079929032706.9cfbb352.png";